import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {SetupPage} from './setup';
import {TranslateModule} from "@ngx-translate/core";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
   SetupPage
  ],
  imports: [
    DirectivesModule,
    HeaderTitleComponentModule,
    IonicPageModule.forChild(SetupPage),
    TranslateModule.forChild(),
  ],
})
export class SetupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/setup/setup.module.ts